import { sendGAEvent } from '@next/third-parties/google';

const googleEventAddWishlist = ({
  itemId,
  title,
  price,
  discount,
}: {
  itemId: string;
  title: string;
  price: number;
  discount: number;
}): any => {
  return sendGAEvent('event', 'add_to_wishlist', {
    currency: 'IRR',
    value: price,
    items: [
      {
        itemId: itemId,
        item_name: title,
        currency: 'IRR',
        price: price,
        discount: discount,
      },
    ],
  });
};
export default googleEventAddWishlist;
